import { CookieSerializeOptions } from 'cookie';

export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT || 'production';
export const CONTENT_CDN = process.env.NEXT_PUBLIC_CONTENT_CDN;
export const CHAT_FRAME_CDN = process.env.NEXT_PUBLIC_CHAT_FRAME_CDN;
export const CDN_API_ENDPOINT = ENVIRONMENT === 'production'
    ? `https://cdn-b2c.dom.ru/${process.env.NEXT_PUBLIC_APP_VERSION}/frontend`
    : '';

export const API_ESIGN_ENDPOINT = process.env.NEXT_PUBLIC_HOST_ESIGN;
export const EGP_IMG = ['sandbox', 'production'].includes(ENVIRONMENT)
    ? '/epgservice/ertelecomipfile/pic/'
    : 'https://xmldata.epgservice.ru/EPGService/hs/xmldata/ertelecomipfile/pic/';
export const CHAT_ENDPOINT = process.env.NEXT_PUBLIC_HOST_CHAT || '/';
export const IS_GTM_DISABLED = process.env.NEXT_PUBLIC_GTM_DISABLED === '1';

// cookies
export const ID_TOKEN_COOKIE = 'ID_TOKEN';
export const NO_CACHE_COOKIE = 'no-cache-key';
export const AGREEMENT_ID_COOKIE = 'userId';
export const COOKIE_MAX_AGE_LONG = 62 * 24 * 60 * 60;
export const COOKIE_MAX_AGE_SHORT = 15 * 60;
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;
export const DEFAULT_COOKIES_CONFIG: CookieSerializeOptions = {
    domain: COOKIE_DOMAIN,
    path: '/',
};
export const PLANK_COOKIE = 'notification_mobile_app';
export const PROVIDER_ID_COOKIE = 'providerId';
export const AUTH_SOURCE_COOKIE = 'source'; // кука источника авторизации

export const ESIA_COOKIE = 'esia-key';
export const ESIA_PARAM_NAME = 'code';
// localStorage
export const LS_TARRIFFS_ACTIVE = 'tariffsActive';

// AB-тесты
export const ABN_TEST_COOKIE = 'abn_test';
export const ABN_VARIANTS_COOKIE = 'abn_variant';
export const ABN_DEFAULT_VARIANT_COOKIE = 'abn_default_variant';

export const REQUEST_TIMEOUT = 15000;

export const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export const MONTHS_GENITIVE = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'];

export const MONTHS_IN = ['Январе', 'Феврале', 'Марте', 'Апреле', 'Мае', 'Июне', 'Июле', 'Августе', 'Сентябре', 'Октябре', 'Ноябре', 'Декабре'];

// @deprecated, use '@r1-frontend/shared/types/EProductsId'
export const PRODUCTS = { internet: 5, tv: 53, ktv: 12, telephony: 31, tvAndInternet: 0, content: 67, intercom: 75, videocontrol: 112, domofon: 75 };

export const SERVICE = { viewManagement: 11740929 };

// Mobile
export const MOBILE_OS = { android: 'Android', iphone: 'Ios' };
export const MOBILE_MARKETS = { apn: 'com.ertelecom.agent', isi: '799358248', ibi: 'com.domru.domruagent' };
export const DEEPLINK = 'https://app.dom.ru/?link=';
export const ANDROID_LINK = 'https://app.dom.ru/android';
export const IPHONE_LINK = 'https://app.dom.ru/ios';
export const DEFAULT_LINK = 'https://app.dom.ru/site';

// Максимальная и минимальная оплата
export const MIN_PAYMENT = 1;
export const MAX_PAYMENT = 150000;


// минимальная и максимальная даты приостановления услуг
export const MIN_SUSPEND_DATE = 7;
export const MAX_SUSPEND_DATE = 124;

export const CONTACT_STATUS_UNCONFIRMED = 'unconfirmed';

export const IS_PRODUCTION_ENVIROMENT = ENVIRONMENT === 'production';
export const IS_SANDBOX_ENVIROMENT = ENVIRONMENT === 'sandbox';
export const IS_LOCAL_ENVIROMENT = ENVIRONMENT === 'localhost';

export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

// соответствие клиентских сервисов и тегов адреса из апи биллинга
export const SERVICE_MAP = {
    int: [5, 31, 112],
    intercom: [75],
    ktv: [12, 32, 53, 116],
    cktv: [12, 32, 53, 116],
    gs: [5, 31, 112],
};

// Текст для отключения спецпредложений
export const DISCONNECT_TEXT = 'При повторном подключении услуги с вашего счета снова спишется абонентская плата согласно условиям акции.';

// Файл оферты на оказание услуг по осуществлению содействия в поиске абонентов 2024
export const DEALERS_OFFER_LINK = 'https://cdn-b2c.dom.ru/content/static/files/2026/2/20/1771573496327.pdf';

// Ключ для гугл-рекапчи
export const RECAPTCHA_SITE_KEY = '6Lf8bBoUAAAAAMdfBfkPmV4r8iqDlQw9tYRsVdPp';

// Путь к спрайту с svg-иконками 24*24 (для кнопок и т.п.)
export const ICONS_PATH = '/static/images/icons-sprite-btn.svg';

// массив чисел для компонентов выбора дня месяца
export const monthDays = [...Array(31)].map((value, index) => value = index + 1);
